export const BOBAME_WIDGET_ID = 'BOBAME_BUTTON'
